export class Pasajero {

public numero: number;
public edad: number;
public edadIngresada: string;
public style: string;
public nombre: string;
public apellido: string;
public documento: string;
public email: string;
public fecha: string;
public paisDestino: string;
public genero: string;

    constructor( numero: number, edad: number,  nombre: string,  apellido: string,  documento: string,  email: string, fecha: string, paisDestino: string, genero: string) {

    this.numero=numero;
    this.edad=edad;
    this.edadIngresada='';
    this.style='';
    this.nombre=nombre;
    this.apellido=apellido;
    this.documento=documento;
    this.email=email;
    this.fecha=fecha;
    this.paisDestino=paisDestino;
    this.genero= genero;

    }
}




// WEBPACK FOOTER //
// ./src/app/obj/pasajero.ts